module.exports = __webpack_public_path__ + "static/empty-states-value-props-body-do-ea7754b58fdb1ec9e5efb2d8f0958333.png";